import { isStatus } from '@/utils'
import { REPORT_STATUSES } from './constants'
import type { Analysis, AnalysisStatusKey } from './stores'

export const isAnalysisGenerating = (analysis: Analysis) =>
  isAnalysisStatus(analysis, 'generating')

export const hasAnalysisGenerated = (analysis: Analysis) =>
  isAnalysisStatus(analysis, 'generated')

export const hasAnalysisFailed = (analysis: Analysis) =>
  isAnalysisStatus(analysis, 'failed')

export const isAnalysisStatus = (
  analysis: Analysis,
  ...expectations: AnalysisStatusKey[]
) => isStatus(REPORT_STATUSES, analysis, 'status', ...expectations)
